/**************************************************
 * Nombre:       Profesional_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useObtenerAlto} from "../../../Utilidades/useObtenerAlto";
import {useRef} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Profesional_Detalle = ({item}) => {
    const {masSM} = useResponsive()
    const refe = useRef()
    const {alto} = useObtenerAlto({elementoRef: refe})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        ref={refe}
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            backgroundColor: 'white',
                            borderRadius: 5,

                        }}
                    >

                        <Grid

                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}
                            sx={{p: 6}}
                        >

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={2}
                                sx={{mt: 0}}
                            >

                                {/*} <Chip color={'primary'} label={'Cosejero Juvenil'} sx={{fontWeight: 600}}/>

                                <Chip color={'primary'} label={'Cosejero Pareja'} sx={{fontWeight: 600}}/> */}

                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                                <Typography sx={{fontSize: 40, fontWeight: 800, lineHeight: 1.1}}>
                                    {item.nombre}
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                                <Typography sx={{fontSize: 18, fontWeight: 400}}>
                                    {item.resumen}
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                {/*} <Chip color={'secondary'} label={'$ 8.000/Hr'} sx={{fontWeight: 800, pt: 0.1}}/>*/}
                            </Grid>

                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}
                            sx={{
                                backgroundColor: 'white',
                                backgroundImage: 'url(' + item.img + ')',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'top right',
                                height: !masSM ? 350 : alto,
                                borderTopRightRadius: 20,
                                borderBottomRightRadius: 20,
                            }}

                        >


                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Profesional_Detalle